import { gql } from "@apollo/client";
import { PRODUCT_FRAGMENT } from "../../fragments/contentful/productFragment";

export const CONTENTFUL_PRODUCT = gql`
  query getContentfulProduct($id: String!) {
    product(id: $id, preview: true) {
      ...product
    }
  }
  ${PRODUCT_FRAGMENT}
`;
